import { Instagram, MessageCircle, Mail, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/reels";
import { useReveal } from "../hooks/useReveal";

const Item = ({ href, icon: Icon, label, value, testid }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="group flex items-center justify-between gap-4 py-5 border-b border-[color:var(--mr-line)] hover:pl-2 transition-all duration-300"
  >
    <div className="flex items-center gap-4">
      <span className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center group-hover:bg-[color:var(--mr-fuchsia)] transition-colors duration-300">
        <Icon size={18} strokeWidth={1.8} />
      </span>
      <div>
        <p className="mono text-[10px] uppercase tracking-widest text-[color:var(--mr-muted)]">{label}</p>
        <p className="display text-[18px] sm:text-[22px] mt-0.5">{value}</p>
      </div>
    </div>
    <ArrowUpRight className="text-[color:var(--mr-ink)] group-hover:text-[color:var(--mr-fuchsia)] transition-all duration-300 group-hover:rotate-12" size={22} />
  </a>
);

export const ContactSection = () => {
  const ref = useReveal();
  return (
    <section id="contacto" className="relative py-16 sm:py-24 px-5">
      <div ref={ref} className="reveal max-w-3xl mx-auto">
        <span className="mono text-xs tracking-[0.3em] uppercase text-[color:var(--mr-fuchsia)]">
          · hablemos ·
        </span>
        <h3 className="display text-[40px] sm:text-[64px] lg:text-[80px] leading-[0.9] mt-3 mb-10">
          cont<span className="text-[color:var(--mr-purple)]">á</span>ctanos
        </h3>

        <div>
          <Item
            testid="contact-instagram"
            href={CONTACT.instagram}
            icon={Instagram}
            label="instagram"
            value="@modoredes"
          />
          <Item
            testid="contact-whatsapp"
            href={CONTACT.whatsapp}
            icon={MessageCircle}
            label="whatsapp"
            value="escríbenos directo"
          />
          <Item
            testid="contact-email"
            href={`mailto:${CONTACT.email}`}
            icon={Mail}
            label="email"
            value={CONTACT.email}
          />
        </div>

        <footer className="mt-16 pt-8 border-t border-[color:var(--mr-line)] flex items-center justify-between text-xs mono text-[color:var(--mr-muted)]">
          <span>© {new Date().getFullYear()} ModoRedes · creative agency</span>
          <span>made with <span className="text-[color:var(--mr-fuchsia)]">♥</span> en valencia</span>
        </footer>
      </div>
    </section>
  );
};
